module.exports = __webpack_public_path__ + "static/img/permission-extension.78f4626.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/browser-extension/permission-extension.jpg
// module id = Sv3K
// module chunks = 1